/* eslint-disable no-lonely-if */
var clientSideValidation = require('../js/components/clientSideValidation');

$(document).ready(function () {
    $('body').on('input', '#signup-form-phone[data-validate-local-phone="true"]', function () {
        var $field = $(this);
        var hasNonNumericCharacters = !/^\d*$/.test($field.val());

        if (hasNonNumericCharacters) {
            $field.trigger('invalid');
        } else if (this.validity.valid && $field.hasClass('is-invalid')) {
            clientSideValidation.functions.clearForm($field.closest('.form-group'));
            $field.closest('.form-group').removeClass('is-invalid');
            $field.closest('.form-group').find('.invalid-feedback').text('');
        }
    });

    /**
    * Clears all previous error messages from the specified form.
    * @param {jQuery} $form - The jQuery object representing the form whose error messages should be cleared.
    */
    function clearPreviousErrors($form) {
        $form.find('.form-error').text('');
    }

    /**
    * Submits the email sign-up form via AJAX and handles the UI updates based on the response.
    * On success, displays the success message and hides the registration form. On failure, displays an error message.
    *
    * @param {jQuery} $form - The jQuery object representing the email sign-up form to be submitted.
    * @param {Object} messages - An object containing localized or default error messages.
    */
    function submitForm($form, messages) {
        $.ajax({
            url: $form.attr('action'),
            type: 'POST',
            data: $form.serialize(),
            success: function (response) {
                if (response.success) {
                    $('.email-signup-tray__main--register').addClass('d-none');
                    $('.email-signup-tray__main--success').removeClass('d-none');
                    $('.email-signup-tray__content-wrap').addClass('success');
                } else {
                    if (response.alreadySubscribed) {
                        $('.js-general-error').removeClass('d-none');
                        $('.js-general-error .toast-error-message').text(response.error);
                    } else {
                        $('.js-general-error').removeClass('d-none');
                        $('.js-general-error .toast-error-message').text(response.error || messages.error);
                    }
                }
            },
            error: function () {
                $form.find('.general-error').text(messages.error);
            }
        });
    }

    /**
     * Handle email signup form submission (both guest & authenticated)
     */
    $('body').on('submit', '#email-signup-form, #email-signup-auth-form', function (e) {
        e.preventDefault();

        var $form = $(this);
        var messages = window.emailSignupMessages;
        var $inputCheckbox = $('#accept-privacy-and-terms-conditions');
        const $trayPopup = $form.closest('.email-signup-tray');

        clearPreviousErrors($form);
        clientSideValidation.checkMandatoryField($form);
        
        if ($inputCheckbox[0].validity.valueMissing) {
            $('.js-email-tnc-error').removeClass('d-none');
        } else {
            $('.js-email-tnc-error').addClass('d-none');
        }

        if (this.checkValidity && this.checkValidity()) {
            submitForm($form, messages);
        }

        $('body').trigger('tray:adjustHeight', [$trayPopup]);
    });
});
